"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaginationTable_1 = require("../PaginationTable");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
require("../../styles/CustomerListPage.css");
require("../../styles/TicketListPageExternal.css");
require("../../styles/ServicePageExternal.css");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var graph_1 = require("../../graph");
var customer_1 = require("../../api/customer");
var classnames_1 = require("classnames");
var subscription_1 = require("../../api/subscription");
var ServicePageExternal = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var _a = (0, react_1.useState)({ id: "" }), graphData = _a[0], setGraphData = _a[1];
    var _b = (0, react_1.useState)({
        id: 0
    }), company = _b[0], setCompany = _b[1];
    var _c = (0, msal_react_1.useMsal)(), inProgress = _c.inProgress, instance = _c.instance, accounts = _c.accounts;
    var _d = React.useState('allAvailableLicenseList'), activeLicenseTab = _d[0], setActiveLicenseTab = _d[1]; //useState('CustomerProfile');
    var _e = React.useState('allAvailableServiceList'), activeServiceTab = _e[0], setActiveServiceTab = _e[1]; //useState('CustomerProfile');
    var _f = React.useState({
        allAvailableLicensesForSubscription: new Array(),
        currentSubscribedServices: new Array(),
        allAvailableServices: new Array(),
        currentSubscribedPackage: new Array(),
    }), serviceData = _f[0], setServiceData = _f[1];
    //const [serviceData, setServiceData] = React.useState({
    //    allAvailableLicensesForSubscription: new Array<any>(),
    //    currentSubscribedLicense: new Array<any>(),
    //    allAvailableServices: new Array<any>(),
    //    currentSubscribedPackage: new Array<any>(),
    //});
    //const [allAvailableLicenseList, setAllAvailableLicenseList] = useState(new Array<any>());
    //const [currentSubscribedLicenseList, setCurrentSubscribedLicenseList] = useState(new Array<any>());
    //const [allAvailableServiceList, setallAvailableServiceList] = useState(new Array<any>());
    //const [currentSubscribedPackageList, setCurrentSubscribedPackageList] = useState(new Array<any>());
    var companyId = parseInt(props.match.params.id, 10) || 0;
    var toggle = function (type, tab) {
        if (type == 'license' && activeLicenseTab !== tab) {
            setActiveLicenseTab(tab);
        }
        if (type == 'service' && activeServiceTab !== tab) {
            setActiveServiceTab(tab);
        }
    };
    var allAvailableLicenseColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Description',
            accessor: 'description'
        }
    ];
    var currentSubscribedServiceColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        }
    ];
    var allAvailableServiceColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Description',
            accessor: 'description'
        }
    ];
    var currentSubscribedPackageColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Scale',
            accessor: 'scale'
        },
        {
            Header: 'Tier',
            accessor: 'tier'
        },
        {
            Header: 'Unit',
            accessor: 'unit'
        }
    ];
    var requestProfileData = function () {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        if (!graphData || graphData.id.length === 0) {
            instance.acquireTokenSilent(__assign(__assign({}, authConfig_1.loginRequest), { account: accounts[0] })).then(function (response) {
                (0, graph_1.callMsGraph)("GET", response.accessToken, authConfig_1.graphConfig.graphMeEndpoint).then(function (response) {
                    setGraphData(response);
                });
            });
        }
    };
    var populateCompany = function () {
        if (graphData != null && graphData.id != null && graphData.id.length > 0 && company.id == 0) {
            (0, customer_1.fetchCustomerByUserId)(graphData.id).then(function (data) {
                console.log('company');
                setCompany(data);
            }).catch(console.error);
        }
    };
    var populateList = function () {
        if (serviceData.allAvailableLicensesForSubscription.length === 0 || serviceData.currentSubscribedServices.length === 0 || serviceData.allAvailableServices.length === 0 || serviceData.currentSubscribedPackage.length === 0) {
            if (company.id > 0) {
                (0, subscription_1.fetchSubscriptionSummary)(company.id).then(function (data) {
                    console.log('sub');
                    console.log(data);
                    setServiceData(data);
                    //setAllAvailableLicenseList(data.allAvailableLicensesForSubscription);
                    //setCurrentSubscribedLicenseList(data.currentSubscribedLicense);
                    //setallAvailableServiceList(data.allAvailableServices);
                    //setCurrentSubscribedPackageList(data.currentSubscribedPackage);
                }).catch(console.error);
            }
        }
    };
    var onLoad = function () {
        //fetchTickets().then((data: any) => {
        //    setList(data.list);
        //}).catch(console.error);
        requestProfileData();
        populateCompany();
        populateList();
    };
    (0, react_1.useEffect)(function () {
        if (inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [instance, inProgress, graphData, setGraphData, company, setCompany, serviceData, setServiceData]);
    //(accounts[0] as AccountInfo) != null && (accounts[0] as AccountInfo).name != null 
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header" },
                React.createElement("div", null,
                    React.createElement("h5", { className: "card-title" }, "Services"))),
            React.createElement(reactstrap_1.Container, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { lg: 6 },
                        React.createElement("div", { className: "Available-section" },
                            React.createElement(reactstrap_1.Nav, { tabs: true },
                                React.createElement(reactstrap_1.NavItem, null,
                                    React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeLicenseTab === 'allAvailableLicenseList' }), onClick: function () { toggle('license', 'allAvailableLicenseList'); } }, "All")),
                                React.createElement(reactstrap_1.NavItem, null,
                                    React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeLicenseTab === 'currentSubscribedPackageList' }), onClick: function () { toggle('license', 'currentSubscribedPackageList'); } }, "Current"))),
                            React.createElement(reactstrap_1.TabContent, { activeTab: activeLicenseTab },
                                React.createElement(reactstrap_1.TabPane, { tabId: "allAvailableLicenseList" },
                                    React.createElement("h5", { className: "padding-default card-title" }, "All Licenses Available for Subscriptions"),
                                    React.createElement("div", { className: "tableContainer servicePageTable" }, serviceData && serviceData.allAvailableLicensesForSubscription ? React.createElement(PaginationTable_1.PaginationTable, { columns: allAvailableLicenseColumns, data: serviceData.allAvailableLicensesForSubscription }) : React.createElement(React.Fragment, null, "Loading..."))),
                                React.createElement(reactstrap_1.TabPane, { tabId: "currentSubscribedPackageList" },
                                    React.createElement("h5", { className: "padding-default card-title" }, "Current Subscribed Package"),
                                    React.createElement("div", { className: "tableContainer servicePageTable" }, serviceData && serviceData.currentSubscribedPackage ? React.createElement(PaginationTable_1.PaginationTable, { columns: currentSubscribedPackageColumns, data: serviceData.currentSubscribedPackage }) : React.createElement(React.Fragment, null, "Loading...")))))),
                    React.createElement(reactstrap_1.Col, { lg: 6 },
                        React.createElement("div", { className: "Available-section" },
                            React.createElement(reactstrap_1.Nav, { tabs: true },
                                React.createElement(reactstrap_1.NavItem, null,
                                    React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeServiceTab === 'allAvailableServiceList' }), onClick: function () { toggle('service', 'allAvailableServiceList'); } }, "All")),
                                React.createElement(reactstrap_1.NavItem, null,
                                    React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeServiceTab === 'currentSubscribedServiceList' }), onClick: function () { toggle('service', 'currentSubscribedServiceList'); } }, "Current"))),
                            React.createElement(reactstrap_1.TabContent, { activeTab: activeServiceTab },
                                React.createElement(reactstrap_1.TabPane, { tabId: "allAvailableServiceList" },
                                    React.createElement("h5", { className: "padding-default card-title" }, "All Services"),
                                    React.createElement("div", { className: "tableContainer  servicePageTable" }, serviceData && serviceData.allAvailableServices ? React.createElement(PaginationTable_1.PaginationTable, { columns: allAvailableServiceColumns, data: serviceData.allAvailableServices }) : React.createElement(React.Fragment, null, "Loading..."))),
                                React.createElement(reactstrap_1.TabPane, { tabId: "currentSubscribedServiceList" },
                                    React.createElement("h5", { className: "padding-default card-title" }, "Current Subscribed Service"),
                                    React.createElement("div", { className: "tableContainer servicePageTable" }, serviceData && serviceData.currentSubscribedServices ? React.createElement(PaginationTable_1.PaginationTable, { columns: currentSubscribedServiceColumns, data: serviceData.currentSubscribedServices }) : React.createElement(React.Fragment, null, "Loading...")))))))))));
};
exports.default = ServicePageExternal;
//# sourceMappingURL=ServicePageExternal.js.map